import * as Accordion from '@radix-ui/react-accordion';
import ArrowDownIcon from '../assets/icons/ArrowDownIcon';
// import ArrowDownIcon from "@/assets/icons/ArrowDownIcon";

export default function PricingFAQ() {
  return (
    <Accordion.Root type="multiple">
      <Accordion.Item value="item-1">
        <AccordionHeader title="How can I cancel or update my credit card?" />
        <AccordionContent>
          Once you log in, visit this pricing page again. Clicking “Manage” under your current plan will allow you to cancel, update your payment method, or download a receipt.
        </AccordionContent>
      </Accordion.Item>
      <Accordion.Item value="item-2" className="mt-2">
        <AccordionHeader title="What payment methods can I use?" />
        <AccordionContent>
          We only accept credit cards and debit cards at the moment.
        </AccordionContent>
      </Accordion.Item>
      <Accordion.Item value="item-3" className="mt-2">
        <AccordionHeader title="When will my quota limits reset and how do I increase my limits?" />
        <AccordionContent>
          Monthly limits reset at the start of each monthly billing cycle. Daily limits are set on a 24hr rolling window. You can upgrade your plan to increase your quota limits.
        </AccordionContent>
      </Accordion.Item>
      <Accordion.Item value="item-4" className="mt-2">
        <AccordionHeader title="I would like to know more about Business and Enterprise pricing plans?" />
        <AccordionContent>
          Contact us at <a href="mailto:support@saagas.ai" className="underline">support@saagas.ai</a> to request more information on these plan. Include Subject: Saagas.ai Business or Enterprise Plan.
        </AccordionContent>
      </Accordion.Item>
      <Accordion.Item value="item-5" className="mt-2">
        <AccordionHeader title="How can I cancel or update my credit card?" />
        <AccordionContent>
          Once you log in, visit this Billing page again. Clicking &quot;Change plan&quot; will allow you to cancel, update your payment method, or download a receipt on
          Stripe.
        </AccordionContent>
      </Accordion.Item>
      <Accordion.Item value="item-6" className="mt-2">
        <AccordionHeader title="Do my credits reset?" />
        <AccordionContent>
          No, credits do not reset. They accumulate each month your subscription is active. Credits that aren&apos;t used for a year after purchase lapse.
        </AccordionContent>
      </Accordion.Item>
      <Accordion.Item value="item-7" className="mt-2">
        <AccordionHeader title="I would like to know more about pricing plans." />
        <AccordionContent>
          Contact us at support@saagas.ai to request more information on these plans. Include Subject: Saagas.ai Pricing Plan.
        </AccordionContent>
      </Accordion.Item>
    </Accordion.Root>
  );
}

const AccordionHeader = ({ title }: { title: string }) => (
  <Accordion.Header>
    <Accordion.Trigger className="flex justify-between font-source-sans text-[1.25rem] font-bold w-full p-4 bg-[#18181B] rounded-[10px] data-[state='open']:rounded-br-none group data-[state='open']:rounded-bl-none data-[state='open']:border-[#393939] data-[state='open']:border-b">
      <span className="text-left">{title}</span>
      <ArrowDownIcon className="group-data-[state='open']:rotate-180 shrink-0" />
    </Accordion.Trigger>
  </Accordion.Header>
);

const AccordionContent = ({ children }: { children: React.ReactNode }) => (
  <Accordion.Content className="p-4 bg-[#18181B] text-sm rounded-bl-[10px] rounded-br-[10px] font-source-sans">
    {children}
  </Accordion.Content>
);
